export default __webpack_public_path__ + "static/media/Ukraine.7056688b.svg";